export const version = 'kunde-v1.15.0-SNAPSHOT-498f468e3e8555ecba440cf6c7e7a5b9366c0747';